/**
 * Accounting Service Form - Entry Point
 * Import và khởi tạo modules cho form dịch vụ kế toán
 */

// ===========================
// IMPORT SHARED MODULES
// ===========================

import * as StateManager from '../shared/state-manager.js';
import * as Utils from '../shared/utils.js';
import * as Validator from '../shared/validator.js';
import * as StorageService from '../shared/storage-service.js';
import * as TrafficTracker from '../shared/traffic-tracker.js';
import * as CustomerService from '../shared/customer-service.js';
import * as CampaignManager from '../shared/campaign-manager.js';

// ===========================
// IMPORT ACCOUNTING MODULES (side-effect: attach to window.KTVHVN)
// ===========================
import './accounting-form.js';
import './accounting-pricing.js';
import './conditional-engine.js';

// ===========================
// JQUERY READY
// ===========================

(function($) {
    'use strict';

    $(document).ready(function() {
        console.log('🚀 KTVHVN Accounting Form - Initialized');

        // Initialize accounting form if it exists
        const accountingFormElement = $('#ktvhvn-accounting-form');
        if (accountingFormElement.length === 0) {
            console.warn('Accounting form not found on this page');
            return;
        }

        // Track traffic source
        TrafficTracker.trackTrafficSource();

        // Load saved customer info
        StorageService.loadCustomerInfo();

        // Initialize accounting form (class attaches to window.KTVHVN)
        // IMPORTANT: Use singleton pattern - only create if not already exists
        // accounting-form.js may have already created window.ktvhvnAccountingForm
        if (!window.ktvhvnAccountingForm) {
            if (window.KTVHVN && typeof window.KTVHVN.AccountingForm === 'function') {
                window.ktvhvnAccountingForm = new window.KTVHVN.AccountingForm();
            } else {
                console.warn('AccountingForm class not available on window.KTVHVN');
            }
        }

        // Initialize conditional logic (if needed independently)
        if (window.KTVHVN && typeof window.KTVHVN.ConditionalEngine === 'function') {
            // Only instantiate if not already created inside AccountingForm
            if (!window.ktvhvnAccountingForm || !window.ktvhvnAccountingForm.conditionalEngine) {
                new window.KTVHVN.ConditionalEngine();
            }
        }

        // Listen to questionnaire price changes
        // IMPORTANT: Always use global instance (window.ktvhvnAccountingForm) to ensure
        // state consistency when questionnaire addon triggers recalculation
        jQuery(document).on('ktvhvn_questionnaire_price_changed', function(event, price) {
            window.ktvhvnQuestionnairePrice = parseFloat(price) || 0;
            // Use global instance to ensure we have the correct service state
            if (window.ktvhvnAccountingForm && typeof window.ktvhvnAccountingForm.calculatePrice === 'function') {
                window.ktvhvnAccountingForm.calculatePrice();
            }
        });

        console.log('✅ Accounting Form initialized successfully!');
    });

})(jQuery);
